export const NVIDIA_SOLUTIONS_ARCHITECT_ORG = "rv1wzrxg3"
export const ACCENTURE_ORG = "bqfgisga2"